import React from 'react';
import { Input, Select, Icon, DatePicker, Col, Row, Radio } from 'antd';
import moment from 'moment';
import { lista_estado } from '../../../common/types/ordenCompraEstadoType';
import auth from "../../../common/utility/auth";
import SelectPlaceHolder from '../../../components/SelectPlaceHolder';
import { VER_SERIES_LOG } from '../../../common/types/configuracionType';


const { Option } = Select;

class Filters extends React.Component {
    render() {

        var flagSerie = this.props.configuraciones.filter((m) => m.abreviatura === VER_SERIES_LOG).length >= 1 ? false : true;

        return (
            <div className="filfer-container">
                <Row gutter={16}>

                    <Col className="gutter-row" sm={24} md={12} lg={7}>

                        <Select
                            showSearch labelInValue
                            value={
                                this.props.filter.idProveedor ?
                                    { key: this.props.filter.idProveedor } : undefined
                            }
                            placeholder={"Seleccione Proveedor"}
                            optionFilterProp="children"
                            onChange={(option) => this.props.onChange('idProveedor', option.key)}
                        >
                            {this.props.entidades.map(item => (
                                <Option key={item.id} value={item.id}>{item.nombre}</Option>
                            ))}
                        </Select>

                    </Col>


                    <Col className="gutter-row" sm={24} md={12} lg={4}>

                        <Select
                            showSearch labelInValue
                            value={
                                this.props.filter.idEstadoOrdenServicio ?
                                    { key: this.props.filter.idEstadoOrdenServicio } : undefined
                            }
                            placeholder={"Seleccione Estado"}
                            optionFilterProp="children"
                            onChange={(option) => this.props.onChange('idEstadoOrdenServicio', option.key)}
                        >
                            {lista_estado.map(item => (
                                <Option key={item.id} value={item.id}>{item.nombre}</Option>
                            ))}
                        </Select>

                    </Col>


                    <Col className="gutter-row" sm={24} md={12} lg={3}>
                        <Input
                            disabled={flagSerie}
                            prefix={<Icon type="filter" style={{ color: 'rgba(0,0,0,.25)' }} />}
                            value={this.props.filter.serie}
                            onChange={(e) => this.props.onChange("serie", e.target.value)}
                            onKeyUp={this.props.onKeyUpSearch}
                            placeholder="Filtrar por serie"
                            autoComplete="off"
                        />
                    </Col>
                    <Col className="gutter-row" sm={24} md={12} lg={3}>
                        <Input
                            prefix={<Icon type="filter" style={{ color: 'rgba(0,0,0,.25)' }} />}
                            value={this.props.filter.documento}
                            onChange={(e) => this.props.onChange("documento", e.target.value)}
                            onKeyUp={this.props.onKeyUpSearch}
                            placeholder="Filtrar por documento"
                            autoComplete="off"
                        />
                    </Col>
                    <Col className="gutter-row" sm={24} md={12} lg={3}>
                        <DatePicker
                            placeholder="Filtrar por fecha inicio"
                            format="DD/MM/YYYY"
                            value={this.props.filter.fechaInicioStr === '' ? null : moment(this.props.filter.fechaInicioStr, 'DD/MM/YYYY')}
                            onChange={(moment, value) => this.props.onChange('fechaInicioStr', value)}
                        />
                    </Col>
                    <Col className="gutter-row" sm={24} md={12} lg={3}>
                        <DatePicker
                            placeholder="Filtrar por fecha fin"
                            format="DD/MM/YYYY"
                            value={this.props.filter.fechaFinStr === '' ? null : moment(this.props.filter.fechaFinStr, 'DD/MM/YYYY')}
                            onChange={(moment, value) => this.props.onChange('fechaFinStr', value)}
                        />
                    </Col>

                    <Col className="gutter-row" sm={24} md={12} lg={4}>
                        <Select
                            showSearch labelInValue
                            value={
                                this.props.filter.idProyecto ?
                                    { key: this.props.filter.idProyecto } : undefined
                            }
                            placeholder={<SelectPlaceHolder label="Filtrar por Proyecto" />}
                            onChange={(option) => this.props.onChange("idProyecto", option.key, option, 'proyecto')}

                            loading={this.props.filter.clienteLoading}
                            optionFilterProp="children"
                        >
                            <Select.Option value="0" key="0">TODOS</Select.Option>
                            {this.props.proyectos.map(item => ( //STATE DATA

                                <Select.Option value={item.id} key={item.id}  >{item.nombre}</Select.Option>

                            ))}
                        </Select>
                    </Col>

                    <Col className="gutter-row" sm={24} md={24} lg={4}>
                        <div style={{ height: '32px', display: 'flex', alignItems: 'center', justifyContent: 'center' }} >
                            <Radio.Group
                                value={this.props.filter.tipoReporte}
                                onChange={(e) => this.props.onChange("tipoReporte", e.target.value)}
                            >
                                <Radio value={1}>Resumen</Radio>
                                <Radio value={2}>Detallado</Radio>
                            </Radio.Group>
                        </div>
                    </Col>
                </Row>
            </div>
        );
    }
}

export default Filters;